import { createContext } from 'react'

import type {
  TaggingContextType,
  TaggingTableSelectionContextType,
} from './TaggingProvider.types'

export const TaggingContext = createContext<TaggingContextType | null>(null)
export const TaggingTableSelectionContext =
  createContext<TaggingTableSelectionContextType | null>(null)
